import {
  IconUser,
  IconUsers,
  IconUserOff,
  IconRobotFace,
  IconMessageCircleOff,
  IconBrandLine,
  IconMessageCircleUser,
  IconUsersGroup,
  IconUserX,
  IconMessages,
  IconMessage,
  IconMessageCircle,
} from '@tabler/icons-react';
import { NavItemType } from 'types';
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';

// constant
const icons = {
  IconUser,
  IconUsers,
  IconUserOff,
  IconRobotFace,
  ForumOutlinedIcon,
  IconMessageCircleOff,
  IconBrandLine,
  IconMessageCircleUser,
  IconUsersGroup,
  IconUserX,
  IconMessages,
  IconMessage,
  IconMessageCircle,
};

const viewsPages: NavItemType = {
  id: 'views-pages',
  title: 'sidebar.nav.views',
  // caption: 'settingsPopup.navigation.conversations.label',
  // icon: icons.IconKey,
  type: 'group',
  children: [
    {
      id: 'chats',
      title: 'sidebar.nav.views.all',
      icon: icons.ForumOutlinedIcon,
      type: 'item',
      url: '/chats',
      breadcrumbs: false,
    },
    {
      id: 'my-chats',
      title: 'sidebar.nav.views.my',
      icon: icons.IconUser,
      type: 'item',
      url: '/chats/my',
      breadcrumbs: false,
    },
    {
      id: 'not-my-chats',
      title: 'sidebar.nav.views.notMy',
              icon: icons.IconUsers,
      type: 'item',
      url: '/chats/not-my',
      breadcrumbs: false,
    },
    {
      id: 'unassigned-chats',
      title: 'sidebar.nav.views.unassigned',
      icon: icons.IconUserOff,
      type: 'item',
      url: '/chats/unassigned',
      breadcrumbs: false,
    },
    {
      id: 'bots-chats',
      title: 'sidebar.nav.views.bots',
      icon: icons.IconRobotFace,
      type: 'item',
      url: '/chats/bots',
      breadcrumbs: false,
    },
  ],
};

export default viewsPages;
